module.exports = __webpack_public_path__ + "img/banner-agencias-desk-min.b1794be6.jpg";